// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"CryptoRewardsPaneLinkButton__linkButton__lOIZU"};